import { useParams } from 'react-router-dom'
import { useAppInfo } from 'hooks/useAppInfo'
import { TermsList } from 'components/TermsList'
import terms from 'services/terms-and-conditions/terms/data'
import termsUsBranch from 'services/terms-and-conditions/terms/data-us-branch'
import { LanguagesEnum } from 'common/enums/languages'
import { normalizeLanguage } from 'utils'
import { Term } from 'services/terms-and-conditions/types'
import { useUserInfo } from 'hooks/useUserInfo'

export function TermsAndConditionsViewer() {
  const { id } = useParams<{ id: string }>()

  const appInfo = useAppInfo()
  const userInfo = useUserInfo()
  const selectedLanguage = normalizeLanguage(appInfo?.language, LanguagesEnum.EN_US)

  if (userInfo.hasBranches) {
    const branchTermsData: Term[] = termsUsBranch[selectedLanguage]
    return <TermsList id={id} termsData={branchTermsData} />
  }

  const termsData: Term[] = terms[selectedLanguage]
  return <TermsList id={id} termsData={termsData} />
}
